import { Box } from '@wix/design-system';
import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import { Search } from '@wix/wix-ui-icons-common/odeditor';
import React from 'react';
import { useIsMobile } from '../../hooks/useIsMobile';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { useResultsPageContext } from './ResultsPageContext';
import { StatusSlot } from './StatusSlot';
export const ResultsSearchBar = _ref => {
  let {
    onSearchSubmit,
    isWixHpMobile = false,
    showUnassignedDomainsOnEmptyInput = false
  } = _ref;
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  const isMobile = useIsMobile();
  const {
    emptyQueryStatus,
    updateUrl,
    isResultsPageOptimizations
  } = useResultsPageContext();
  const mobilePlaceholder = isWixHpMobile ? t('domains_search_gate.anon.results.empty_state.searchbar.placeholder') : t('domains-search-suite-translations-ns:DomainSearch.Mobile.searchInput.placeholder');
  return /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.DomainSearchBar, {
    compact: true,
    showSearchIcon: isResultsPageOptimizations && !isMobile,
    submitIcon: isWixHpMobile ? /*#__PURE__*/React.createElement(Box, {
      verticalAlign: "middle",
      align: "center",
      scale: "1.3"
    }, /*#__PURE__*/React.createElement(Search, {
      color: "white"
    })) : undefined,
    emphasized: isWixHpMobile,
    hideClearButton: isWixHpMobile,
    hideFilters: isResultsPageOptimizations,
    showOptionsIfEmptyInput: showUnassignedDomainsOnEmptyInput,
    hideUnassignedDomains: !showUnassignedDomainsOnEmptyInput,
    autoFocus: isWixHpMobile,
    useModalToolbar: isMobile,
    placeholder: isMobile ? mobilePlaceholder : undefined,
    onSubmit: filters => {
      updateUrl(filters);
      onSearchSubmit == null || onSearchSubmit(filters);
    },
    onFiltersChange: (key, value) => {
      if (key === 'tlds') {
        DomainSearchSuiteModule.internals.bi.onSelectTld == null || DomainSearchSuiteModule.internals.bi.onSelectTld({
          tld: JSON.stringify(value)
        });
      } else {
        DomainSearchSuiteModule.internals.bi.onCTAClick == null || DomainSearchSuiteModule.internals.bi.onCTAClick({
          ctaClick: key,
          value: JSON.stringify(value)
        });
      }
    },
    Layouts: {
      StatusComponent: () => /*#__PURE__*/React.createElement(StatusSlot, {
        emptyQueryStatus: emptyQueryStatus
      })
    }
  });
};
//# sourceMappingURL=ResultsSearchBar.js.map